import { render, staticRenderFns } from "./RunnitBoardsFilterMenu.vue?vue&type=template&id=fd3e0b60"
import script from "./RunnitBoardsFilterMenu.vue?vue&type=script&lang=ts"
export * from "./RunnitBoardsFilterMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports